import React from 'react';
import styled from 'styled-components';
import { colors } from '../theme/colors';
import { shadows } from '../theme/shadows';

const Input = ({
  label,
  helpText,
  error,
  disabled = false,
  size = 'medium',
  className,
  onChange,
  ...props
}) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value, e);
    }
  };

  return (
    <InputWrapper className={className}>
      {label && (
        <InputLabel>
          {label}
        </InputLabel>
      )}
      {helpText && (
        <HelpText>
          {helpText}
        </HelpText>
      )}
      <StyledInput
        size={size}
        disabled={disabled}
        hasError={!!error}
        onChange={handleChange}
        {...props}
      />
      {error && (
        <ErrorText>
          {error}
        </ErrorText>
      )}
    </InputWrapper>
  );
};

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 4px;
`;

const InputLabel = styled.label`
  margin-bottom: 6px;
  display: block;
  font-weight: 500;
  font-size: 14px;
  color: ${colors.neutral[800]};
`;

const HelpText = styled.div`
  margin-bottom: 6px;
  font-size: 12px;
  color: ${colors.neutral[600]};
`;

const StyledInput = styled.input`
  border-radius: 20px;
  border: 2px solid ${({ hasError }) => hasError ? colors.error.main : colors.neutral[200]};
  padding: 12px 20px;
  transition: all 0.3s ease;
  font-size: 16px;
  box-sizing: border-box;
  background: white;
  width: 100%;

  ${({ size }) => {
    switch (size) {
      case 'small':
        return `
          min-height: 40px;
          height: 40px;
          padding: 8px 16px;
          font-size: 14px;
        `;
      case 'large':
        return `
          min-height: 56px;
          height: 56px;
          padding: 16px 24px;
          font-size: 18px;
        `;
      default:
        return `
          min-height: 48px;
          height: 48px;
          padding: 12px 20px;
          font-size: 16px;
        `;
    }
  }}

  &::placeholder {
    color: ${colors.neutral[500]};
  }

  &:hover:not(:disabled) {
    border-color: ${({ hasError }) => hasError ? colors.error.main : colors.primary.main};
    box-shadow: ${shadows.hover.sm};
  }

  &:focus {
    outline: none;
    border-color: ${({ hasError }) => hasError ? colors.error.main : colors.primary.main};
    box-shadow: ${({ hasError }) => hasError ? `0 0 0 3px ${colors.error.light}` : shadows.focus};
  }

  &:disabled {
    background: ${colors.neutral[100]};
    border-color: ${colors.neutral[300]};
    color: ${colors.neutral[500]};
    cursor: not-allowed;
  }
`;

const ErrorText = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: ${colors.error.main};
  font-weight: 500;
`;

export default Input;
